
const League = () => import ('../views/League')
export default [
  // {
  //   path: '/League',
  //   name: 'League',
  //   component: League
  // },
]